"use client";

import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!email) return;

    setStatus("loading");
    try {
      const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL || "http://localhost:4000"}/api/newsletter/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();
      if (res.ok) {
        setStatus("success");
        setMessage(data.message || "Welcome to our newsletter!");
        setEmail("");
      } else {
        setStatus("error");
        setMessage(data.error || "Something went wrong.");
      }
    } catch (err) {
      setStatus("error");
      setMessage("Failed to connect to server.");
    }
  }

  return (
    <div className="w-full max-w-md mx-auto">
      <AnimatePresence mode="wait">
        {status === "success" ? (
          <motion.div
            key="success"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            className="text-center py-4"
          >
            <p className="text-sm font-light italic" style={{ color: "#C9A84C", fontFamily: "'Cormorant', serif" }}>
              {message}
            </p>
          </motion.div>
        ) : (
          <motion.form
            key="form"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            onSubmit={handleSubmit}
            className="relative"
          >
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={status === "loading"}
                className="flex-1 bg-transparent px-4 py-3 text-xs outline-none transition-all"
                style={{
                  border: "1px solid rgba(201,168,76,0.2)",
                  color: "#F5F0E8",
                  fontFamily: "'Montserrat', sans-serif"
                }}
                onFocus={(e) => (e.target.style.borderColor = "rgba(201,168,76,0.5)")}
                onBlur={(e) => (e.target.style.borderColor = "rgba(201,168,76,0.2)")}
                required
              />
              <button
                type="submit"
                disabled={status === "loading"}
                className="px-8 py-3 text-[10px] tracking-[0.2em] uppercase transition-all duration-300 disabled:opacity-50"
                style={{
                  background: "linear-gradient(135deg, #C9A84C, #E8D5A3)",
                  color: "#0A0908",
                  fontFamily: "'Montserrat', sans-serif",
                  fontWeight: 600
                }}
              >
                {status === "loading" ? "Joining..." : "Subscribe"}
              </button>
            </div>
            {status === "error" && (
              <p className="mt-2 text-[10px] text-red-400 font-light uppercase tracking-widest">{message}</p>
            )}
          </motion.form>
        )}
      </AnimatePresence>
    </div>
  );
}
